import { RichTextEditor as MRichTextEditor } from '@mantine/tiptap';
import classes from './richTextEditor.module.scss';

export const RichTextEditor = MRichTextEditor.extend({
  classNames: classes,
});
